import React from 'react';
import { capitalize, Typography, alpha } from '@mui/material';
import { dsColorNew } from "@palette"
import { AppProviderBlock } from "@components"

// Rows come flattened (see groupByBranch): a grey row per branch, then one row per provider.
export default function officeColumn() {
    return {
        name: 'name',
        setBodyCellProps: (_, row) => ({
            sx: {
                p: 1,
                pl: 2,
                backgroundColor: row?.isBranch ? dsColorNew.pillTrackBg : dsColorNew.white,
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                boxShadow: row?.isBranch ? "none" : `6px 0 8px -6px ${alpha(dsColorNew.textTitle, 0.18)}`,
                whiteSpace: 'nowrap',
                userSelect: 'none',
                cursor: 'default',
                position: 'sticky',
                left: 0,
                zIndex: '150 !important',
            },
        }),
        render: (name, row) => row?.isBranch
            ? <Typography variant="body2" fontWeight={600} color={dsColorNew.textTitle}>{name}</Typography>
            : <Typography variant="body2" component="div" fontWeight={500} color={dsColorNew.textDark}><AppProviderBlock provider={capitalize(name)}/></Typography>
    };
}
